declare let Blockly;

const possibleBlockTypes = [
    'text',
    'ap_authModel',
    'attributes.parameters',
    'attributes.headers',
    'get_a_key_from_payload'
];

export function generatorBlockForAcceleratorVariable(block_type, value, name) {
    return new Promise((resolve, reject) => {
        if (possibleBlockTypes.includes(block_type)) {
            let response: any;
            if (block_type === 'text') {
                response = Blockly.Xml.textToDom('<block type="text"><field name="TEXT">' + value + '</field></block>');
            }
            if (block_type === 'attributes.parameters') {
                response = Blockly.Xml.textToDom('<block type="attributes"><field name="MODE">Parameter.' + name + '</field></block>');
            }
            if (block_type === 'attributes.headers') {
                response = Blockly.Xml.textToDom('<block type="attributes"><field name="MODE">Header.' + name + '</field></block>');
            }
            if (block_type === 'get_a_key_from_payload') {
                response = Blockly.Xml.textToDom('<block type="get_a_key_from_json_object"><value name="key"><block type="text"><field name="TEXT">' + name + '</field></block></value><value name="object"><block type="attributes"><field name="MODE">Payload</field></block></value></block>');
            }

            if (block_type === 'ap_authModel') {
                if (value.authType === 'basic_authentication') {
                    response = Blockly.Xml.textToDom('<block type="basic_authentication">' +
                        '<value name="username"><block type="text"><field name="TEXT">' + value.authAttributes.username + '</field></block></value>' +
                        '<value name="password"><block type="text" ><field name="TEXT">' + value.authAttributes.password + '</field></block></value>' +
                        '</block>');
                } else if (value.authType === 'bearer_token') {
                    response = Blockly.Xml.textToDom('<block type="bearer_token">' +
                        '<value name="token"><block type="text"><field name="TEXT">' + value.authAttributes.token + '</field></block></value></block>');
                } else if (value.authType === 'oauth_2_0') {
                    response = Blockly.Xml.textToDom('<block type="oauth_2_0">' +
                        '<value name="access_token"><block type="text"><field name="TEXT">' + value.authAttributes.access_token + '</field></block></value></block>');
                } else if (value.authType === 'aws_signature') {
                    let xml = '<block type="aws_signature">';
                    if (value.authAttributes.accessKeyID) {
                        xml += '<value name="accessKeyID"><block type="text"><field name="TEXT">' + value.authAttributes.accessKeyID + '</field></block></value>';
                    }
                    if (value.authAttributes.regionName) {
                        xml += '<value name="secretAccessKey"><block type="text"><field name="TEXT">' + value.authAttributes.regionName + '</field></block></value>';
                    }
                    if (value.authAttributes.secretAccessKey) {
                        xml += '<value name="regionName"><block type="text"><field name="TEXT">' + value.authAttributes.secretAccessKey + '</field></block></value>';
                    }
                    if (value.authAttributes.serviceName) {
                        xml += '<value name="serviceName"><block type="text"><field name="TEXT">' + value.authAttributes.serviceName + '</field></block></value>';
                    }
                    if (value.authAttributes.sessionToken) {
                        xml += '<value name="session-token"><block type="text"><field name="TEXT">' + value.authAttributes.sessionToken + '</field></block></value>';
                    }
                    xml += '</block>';
                    response = Blockly.Xml.textToDom(xml);
                } else if (value.authType === 'connector') {
                    if (value.authAttributes.producer && value.authType && value.authAttributes.name) {
                        response = Blockly.Xml.textToDom('<block type="connector">' +
                            '<value name="connector"><block type="api_connector"><field name="MODE">' + value.authAttributes.producer + '_' + value.authType + '_' + value.authAttributes.name + '</field></block></value></block>');
                    }
                }
            }
            resolve(response);
        } else {
            reject('Invalid block_type: ' + block_type);
        }
    });
}
